import { formatString } from ".";
import { ObjectMap } from "../entities/object-map";

export const xlate = (phrase: string, values?: ObjectMap<unknown>) => {
    if(values === undefined) {
        return phrase;
    }

    const result = formatString(phrase, values);
    if(result.success) {
        return result.formattedString;
    } else {
        console.error(result.error);
        return '';
    }
};

export const xlationContext = (context: string) => {}